function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onMounted, ref, watch, getCurrentInstance } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import PreviewBtn from "./preview-btn.vue";
import EditBtn from "./edit-btn.vue";
import searchMixin from "@/mixin/search";
import _ from "lodash";
import { downloadWithNewWindow } from "@/common/download.js";
import { v2Host } from "@/config/host";
import qs from "qs";
import { format } from "date-fns";
import { getCaseList, updateCaseStatus } from "@/api/material/case";
import { producerList, serviceTypeList, productionTypeList, gradeList, caseAuthTypeList } from "@/common/demand";
import { statusOptions } from "./options";
import { getCaseOptions, getPlayMethodListByIds } from "./case";
export default defineComponent({
    components: {
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination,
        PreviewBtn: PreviewBtn,
        EditBtn: EditBtn
    },
    mixins: [
        searchMixin
    ],
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var listLoading = ref(false);
        var playMethodList = ref([]);
        var dofList = ref([]);
        var nativeList = ref([]);
        var projectTagOptions = ref([]);
        var subCategoryOptions = ref([]);
        var secondTagOptions = ref([]);
        var thirdTagOptions = ref([]);
        var templateNameOptions = ref([]);
        var list = ref([]);
        var total = ref(1);
        var query1 = ref({
            product_name: "",
            project_tag: "",
            sub_category: undefined,
            second_tag: undefined,
            third_tag: undefined,
            producer: "",
            service_type: undefined,
            production_type: undefined,
            play_methods: "",
            template_id: undefined,
            native: undefined,
            dof: undefined,
            adv_id: undefined,
            grade: undefined,
            adv_auth_type: undefined,
            auth_type: undefined,
            status: undefined,
            page: 1,
            page_size: 15
        });
        var formItemList = computed(function() {
            return [
                {
                    type: "input",
                    prop: "product_name",
                    subtype: "text",
                    params: {
                        clearable: true,
                        placeholder: "\u4EA7\u54C1\u540D\u79F0"
                    }
                },
                {
                    type: "select",
                    prop: "project_tag",
                    params: {
                        placeholder: "\u4EA7\u54C1\u5782\u7C7B",
                        filterable: true,
                        "collapse-tags": true,
                        remote: true,
                        clearable: true,
                        remoteMethod: function(query) {
                            return getProjectTag(query);
                        },
                        options: projectTagOptions.value
                    }
                },
                {
                    type: "select",
                    prop: "sub_category",
                    params: {
                        placeholder: "\u4EA7\u54C1\u5206\u7EC4",
                        filterable: true,
                        "collapse-tags": true,
                        remote: true,
                        clearable: true,
                        remoteMethod: function(query) {
                            return getSubCategory(query);
                        },
                        options: subCategoryOptions.value
                    }
                },
                {
                    type: "select",
                    prop: "second_tag",
                    params: {
                        placeholder: "Second Tag",
                        filterable: true,
                        "collapse-tags": true,
                        remote: true,
                        clearable: true,
                        remoteMethod: function(query) {
                            return getSecondTag(query);
                        },
                        options: secondTagOptions.value
                    }
                },
                {
                    type: "select",
                    prop: "third_tag",
                    params: {
                        placeholder: "Third Tag",
                        filterable: true,
                        "collapse-tags": true,
                        remote: true,
                        clearable: true,
                        remoteMethod: function(query) {
                            return getThirdTag(query);
                        },
                        options: thirdTagOptions.value
                    }
                },
                {
                    type: "select",
                    prop: "template_id",
                    params: {
                        placeholder: "Template Name",
                        filterable: true,
                        "collapse-tags": true,
                        remote: true,
                        clearable: true,
                        remoteMethod: function(query) {
                            return getTemplateName(query);
                        },
                        options: templateNameOptions.value
                    }
                },
                {
                    prop: "producer",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "\u63D0\u4F9B\u5546",
                        options: producerList
                    }
                },
                {
                    prop: "service_type",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "Service Type",
                        options: serviceTypeList
                    }
                },
                {
                    prop: "production_type",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "Production Type",
                        options: productionTypeList
                    }
                },
                {
                    type: "cascader",
                    prop: "play_methods",
                    params: {
                        clearable: true,
                        props: {
                            children: "child",
                            emitPath: false,
                            multiple: true,
                            label: "name",
                            value: "id"
                        },
                        placeholder: "\u73A9\u6CD5\u6807\u7B7E",
                        "collapse-tags": true,
                        "show-all-levels": false,
                        options: playMethodList.value
                    }
                },
                {
                    prop: "native",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "\u662F\u5426\u539F\u751F",
                        options: nativeList.value
                    }
                },
                {
                    prop: "grade",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "\u5206\u6863",
                        options: gradeList
                    }
                },
                {
                    prop: "adv_auth_type",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "\u6388\u6743\u60C5\u51B5\uFF08\u5BA2\u6237\uFF09",
                        options: caseAuthTypeList
                    }
                },
                {
                    prop: "auth_type",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "\u6388\u6743\u60C5\u51B5\uFF08\u7D20\u6750\u7EF4\u5EA6\uFF09",
                        options: caseAuthTypeList
                    }
                },
                {
                    prop: "status",
                    type: "select",
                    params: {
                        clearable: true,
                        placeholder: "\u5C55\u793A\u88AB\u9690\u85CF\u6570\u636E",
                        options: statusOptions
                    }
                }, 
            ];
        });
        function getProjectTag(name) {
            return _getProjectTag.apply(this, arguments);
        }
        function _getProjectTag() {
            _getProjectTag = _asyncToGenerator(regeneratorRuntime.mark(function _callee(name) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCaseOptions("project_tag", name);
                        case 2:
                            projectTagOptions.value = _ctx.sent;
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getProjectTag.apply(this, arguments);
        }
        function getSubCategory(name) {
            return _getSubCategory.apply(this, arguments);
        }
        function _getSubCategory() {
            _getSubCategory = _asyncToGenerator(regeneratorRuntime.mark(function _callee(name) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCaseOptions("sub_category", name);
                        case 2:
                            subCategoryOptions.value = _ctx.sent;
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getSubCategory.apply(this, arguments);
        }
        function getSecondTag(name) {
            return _getSecondTag.apply(this, arguments);
        }
        function _getSecondTag() {
            _getSecondTag = _asyncToGenerator(regeneratorRuntime.mark(function _callee(name) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCaseOptions("second_tag", name);
                        case 2:
                            secondTagOptions.value = _ctx.sent;
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getSecondTag.apply(this, arguments);
        }
        function getThirdTag(name) {
            return _getThirdTag.apply(this, arguments);
        }
        function _getThirdTag() {
            _getThirdTag = _asyncToGenerator(regeneratorRuntime.mark(function _callee(name) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCaseOptions("third_tag", name);
                        case 2:
                            thirdTagOptions.value = _ctx.sent;
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getThirdTag.apply(this, arguments);
        }
        function getTemplateName(name) {
            return _getTemplateName.apply(this, arguments);
        }
        function _getTemplateName() {
            _getTemplateName = _asyncToGenerator(regeneratorRuntime.mark(function _callee(name) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCaseOptions("template_id", name);
                        case 2:
                            templateNameOptions.value = _ctx.sent;
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getTemplateName.apply(this, arguments);
        }
        var tableColumnConfig = computed(function() {
            return [
                {
                    label: "\u57FA\u7840\u5305ID",
                    prop: "basic_id"
                },
                {
                    label: "\u7F29\u7565\u56FE",
                    width: 100,
                    prop: "thumb_url",
                    type: "image",
                    params: {
                        preview: true
                    }
                },
                {
                    label: "\u9700\u6C42ID",
                    prop: "demand_id"
                },
                {
                    label: "\u5BA2\u6237\u540D\u79F0",
                    prop: "adv_name"
                },
                {
                    label: "\u4EA7\u54C1\u540D\u79F0",
                    prop: "product_name"
                },
                {
                    label: "\u5305\u540D",
                    prop: "package_names"
                },
                {
                    label: "\u4EA7\u54C1\u5782\u7C7B",
                    prop: "project_tag"
                },
                {
                    label: "\u4EA7\u54C1\u5206\u7EC4",
                    prop: "sub_category"
                },
                {
                    label: "Second Tag",
                    prop: "second_tag"
                },
                {
                    label: "Third Tag",
                    prop: "third_tag"
                },
                {
                    label: "Producer",
                    prop: "producer"
                },
                {
                    label: "Service Type",
                    prop: "service_type",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            if (row.service_type) {
                                var item1 = serviceTypeList.filter(function(item) {
                                    return row["service_type"] === item.value;
                                });
                                return item1.length ? item1[0].label : row.service_type;
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "Production Type",
                    prop: "production_type",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            if (row.production_type) {
                                var item3 = productionTypeList.filter(function(item) {
                                    return row["production_type"] === item.value;
                                });
                                return item3.length ? item3[0].label : row.production_type;
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "Template ID",
                    prop: "template_id"
                },
                {
                    label: "Template Name",
                    prop: "template_name"
                },
                {
                    label: "\u73A9\u6CD5\u6807\u7B7E",
                    prop: "play_methods"
                },
                {
                    label: "\u662F\u5426\u539F\u751F",
                    prop: "native_name"
                },
                {
                    label: "\u5206\u6863",
                    prop: "grade",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            if (row.grade) {
                                var item5 = gradeList.filter(function(item) {
                                    return row["grade"] === item.value;
                                });
                                return item5.length ? item5[0].label : row.grade;
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "\u53C2\u8003\u552E\u4EF7",
                    prop: "price"
                },
                {
                    label: "\u5B9E\u9645\u552E\u4EF7",
                    prop: "actual_price"
                },
                {
                    label: "\u6388\u6743\u60C5\u51B5\uFF08\u5BA2\u6237\uFF09",
                    prop: "adv_auth_type",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            if (row.adv_auth_type) {
                                var item7 = caseAuthTypeList.filter(function(item) {
                                    return row["adv_auth_type"] === item.value;
                                });
                                return item7.length ? item7[0].label : row.adv_auth_type;
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "\u6388\u6743\u60C5\u51B5\uFF08\u7D20\u6750\u7EF4\u5EA6\uFF09",
                    prop: "auth_type",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            if (row.auth_type) {
                                var item9 = caseAuthTypeList.filter(function(item) {
                                    return row["auth_type"] === item.value;
                                });
                                return item9.length ? item9[0].label : row.auth_type;
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "\u81EA\u7531\u5EA6",
                    prop: "dof_name"
                },
                {
                    label: "Publish Date",
                    prop: "publish_time"
                },
                {
                    label: "\u8BF4\u660E",
                    prop: "description"
                },
                {
                    label: "\u662F\u5426\u9690\u85CF",
                    prop: "status",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            if (row.status) {
                                var item11 = statusOptions.filter(function(item) {
                                    return row["status"] === item.value;
                                });
                                return item11.length ? item11[0].label : row.status;
                            }
                            return "-";
                        }
                    }
                },
                {
                    label: "\u662F\u5426\u5DF2\u7F16\u8F91",
                    prop: "is_editor",
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            return row.is_editor === 1 ? "\u5DF2\u7F16\u8F91" : "\u672A\u7F16\u8F91";
                        }
                    }
                },
                {
                    prop: "action-cell",
                    slot: "action-cell"
                }, 
            ];
        });
        function initList(data) {
            return _initList.apply(this, arguments);
        }
        function _initList() {
            _initList = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            listLoading.value = true;
                            _ctx.next = 4;
                            return getCaseList(data);
                        case 4:
                            res = _ctx.sent;
                            listLoading.value = false;
                            list.value = (_.get(res, "data.data.list") || []).map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    publish_time: item.publish_time ? format(item.publish_time * 1000, "YYYY-MM-DD HH:mm:ss") : "-",
                                    play_methods: getPlayMethodListByIds(item.play_methods, playMethodList.value)
                                });
                            });
                            total.value = _.get(res, "data.data.total");
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            listLoading.value = false;
                            console.log(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return _initList.apply(this, arguments);
        }
        function initOption() {
            return _initOption.apply(this, arguments);
        }
        function _initOption() {
            _initOption = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return root.$store.dispatch("config/getInteractionTagsConfig");
                        case 2:
                            res = _ctx.sent;
                            playMethodList.value = (_.get(res, "play_methods") || []).map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.name,
                                    value: item.id
                                });
                            }) || [];
                            dofList.value = (_.get(res, "dof") || []).map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.name,
                                    value: item.id
                                });
                            }) || [];
                            nativeList.value = (_.get(res, "native") || []).map(function(item) {
                                return _objectSpreadProps(_objectSpread({}, item), {
                                    label: item.name,
                                    value: item.id
                                });
                            }) || [];
                            getProjectTag("");
                            getSubCategory("");
                            getSecondTag("");
                            getThirdTag("");
                            getTemplateName("");
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _initOption.apply(this, arguments);
        }
        function handleHideStatus(row) {
            return _handleHideStatus.apply(this, arguments);
        }
        function _handleHideStatus() {
            _handleHideStatus = _asyncToGenerator(regeneratorRuntime.mark(function _callee(row) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            listLoading.value = true;
                            _ctx.next = 4;
                            return updateCaseStatus({
                                id: row.id,
                                status: row.status === 1 ? 2 : 1
                            });
                        case 4:
                            initList(query1.value);
                            listLoading.value = false;
                            _ctx.next = 12;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            listLoading.value = false;
                            console.log(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return _handleHideStatus.apply(this, arguments);
        }
        function handleExport() {
            return _handleExport.apply(this, arguments);
        }
        function _handleExport() {
            _handleExport = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                downloadWithNewWindow("".concat(v2Host, "/material/case/export?").concat(qs.stringify(query1.value)), "");
                            } catch (error) {
                                console.log(error);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _handleExport.apply(this, arguments);
        }
        onMounted(function() {
            initOption();
            initList(query1.value);
        });
        watch(function() {
            return root.$route;
        }, function() {
            initList(query1.value);
        });
        return {
            query: query1,
            listLoading: listLoading,
            list: list,
            formItemList: formItemList,
            tableColumnConfig: tableColumnConfig,
            total: total,
            initList: initList,
            handleHideStatus: handleHideStatus,
            handleExport: handleExport
        };
    }
});
